export default "__VITE_ASSET__D2h7Q$wG__"